module.exports = __webpack_public_path__ + "img/parking-lot-6.289a80b5.jpg";